<div class="justify-content-start align-items-start inline-flex gap-1">
  <div class="align-items-start justify-content-start flex">
    <div class="font-normal label__name">
      <label [htmlFor]="inputId()">
        {{ labelText() }}
      </label>
    </div>
  </div>
</div>
